import React from "react";
import { Button, Glyphicon, Row, Col } from "react-bootstrap";

import BudgetStore from "../stores/BudgetStore";
import CategoryStore from "../stores/CategoryStore";
import UserStore from "../stores/UserStore";

import BudgetActions from "../actions/BudgetActions";
import CategoryActions from "../actions/CategoryActions";

import BudgetTemplateEdit from "./BudgetTemplateEdit";
import DateHelper from "../utils/DateHelper";

const placeholder = document.createElement("div");
placeholder.className = "placeholder";

export default class BudgetTemplates extends React.Component
{
	constructor(props)
	{
		super(props);

		let state = BudgetTemplates.getStoreState();
		state.showBudgetAuditModal = false;
		state.showBudgetModal = false;
		state.showEditModal = false;
		state.editTemplate = null;
		state.runningBudgetTemplate = false;
		state.templatesRunSuccess = [];
		state.templatesRunError = [];
		this.state = state;

		this._onChange = this._onChange.bind(this);
		this.handleShowBudgetModal = this.handleShowBudgetModal.bind(this);
		this.handleBudgetModalClose = this.handleBudgetModalClose.bind(this);
	}

	static getStoreState()
	{
		return {
			budgetAllocations: BudgetStore.getAllocations(),
			budgetTemplates: BudgetStore.getTemplates(),
			categories: CategoryStore.getCategories()
		};
	}

	handleBudgetTemplateDelete(id)
	{
		BudgetActions.deleteBudgetTemplate(id);
	}

	async handleBudgetTemplateRun(id)
	{
		this.setState({ runningBudgetTemplate: true });
		const templatesRunSuccess = this.state.templatesRunSuccess;
		const templatesRunError = this.state.templatesRunError;

		const startTime = new Date();
		try
		{
			await BudgetActions.runBudgetTemplate(id);
			templatesRunSuccess.push(id);
		}
		catch (err)
		{
			console.error(err);
			templatesRunError.push(id);
		}

		const endTime = new Date();

		// This bit of logic here ensures the button is disabled for at least 1 sec
		// Otherwise it looks pretty odd to the user
		const diffMillis = endTime - startTime;
		if (diffMillis < 1000)
		{
			this._enableRunButtonsTimeoutId = setTimeout(() => {
				this.setState({runningBudgetTemplate: false, templatesRunSuccess, templatesRunError});
			}, 1000-diffMillis);
		}
		else
		{
			this.setState({runningBudgetTemplate: false, templatesRunSuccess, templatesRunError});
		}
	}

	handleShowBudgetModal(editTemplate)
	{
		this.setState({
			showBudgetModal: true,
			editTemplate: editTemplate || null
		});
	}

	handleBudgetModalClose()
	{
		this.setState({
			showBudgetModal: false,
			editTemplate: null
		});
	}

	_onChange()
	{
		this.setState(BudgetTemplates.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);

		BudgetStore.addChangeListener(this._onChange);
		BudgetActions.initialize();

		CategoryStore.addChangeListener(this._onChange);
		CategoryActions.initialize();
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
		BudgetStore.removeChangeListener(this._onChange);
		CategoryStore.removeChangeListener(this._onChange);

		if (this._enableRunButtonsTimeoutId)
		{
			clearTimeout(this._enableRunButtonsTimeoutId);
		}
	}

	render()
	{
		let budgetItems = this.state.budgetAllocations;

		const {budgetTemplates, categories, templatesRunSuccess, templatesRunError} = this.state;
		const canRenderTemplates = !!(budgetTemplates && budgetTemplates.length && categories && categories.length);

		return (
			<Row>
				{this.state.showBudgetModal &&
					<BudgetTemplateEdit
						budgetItems={budgetItems}
						onClose={this.handleBudgetModalClose}
						initialTemplate={this.state.editTemplate}
					/>
				}
				<Col xs={8} xsOffset={2} onDragOver={this.handleDragOver}>
					<Row>
						<Col xs={12}>
							<button className="btn btn-primary" onClick={this.handleShowBudgetModal.bind(this, null)}>Create Budget</button>
						</Col>
					</Row>
					{canRenderTemplates && budgetTemplates.map(budgetTemplate =>
					{
						const hasBeenRunSuccess = templatesRunSuccess.indexOf(budgetTemplate.id) !== -1;
						const hasBeenRunError = templatesRunError.indexOf(budgetTemplate.id) !== -1;
						const hasBeenRun = hasBeenRunSuccess || hasBeenRunError;
						let dateString =  "never";
						if (budgetTemplate.lastRun)
						{
							dateString = DateHelper.formatDate(budgetTemplate.lastRun);
						}
						return (
							<Row key={"template_" + budgetTemplate.id}>
								<Col md={12}>
									<span>{budgetTemplate.description}:&nbsp;</span>
									<button className="btn btn-sm btn-primary" onClick={this.handleShowBudgetModal.bind(this, budgetTemplate)}>Edit</button>
									{hasBeenRunSuccess &&
										<Button className="btn btn-sm btn-success"><Glyphicon glyph={"ok"}/></Button>
									}
									{hasBeenRunError &&
										<Button className="btn btn-sm btn-danger"><Glyphicon glyph={"alert"}/></Button>
									}
									{!hasBeenRun &&
										<Button
											className="btn btn-sm btn-primary"
											onClick={this.handleBudgetTemplateRun.bind(this, budgetTemplate.id)}
											disabled={this.state.runningBudgetTemplate}
										>Run</Button>
									}
									<Button
										bsSize={"sm"}
										bsStyle={"danger"}
										onClick={this.handleBudgetTemplateDelete.bind(this, budgetTemplate.id)}
									>
										<Glyphicon glyph={"trash"} />
									</Button>
									<span>&nbsp;Last Run: {dateString}</span>
								</Col>
							</Row>
						);
					})}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/BudgetTemplates.jsx